import React, { useEffect, useMemo, useState } from 'react';
import { Oval } from 'react-loader-spinner';
import api from '../services/api';
import LazyImage from '../components/LazyImage';
import { Page, Header, HeaderCard, HeaderImage, Section, SectionTitle, Grid, Card } from './PartnershipsStyles';

const SECTIONS = [
  { key: 'advisory', label: 'Advisory Committee' },
  { key: 'scientific', label: 'Scientific Committee' },
  { key: 'partners', label: 'Partners' }
];

const Partnerships = () => {
  const [page, setPage] = useState(null);
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      api.partnerships.getPage(),
      api.partners.list()
    ]).then(([p, list]) => {
      if (!mounted) return;
      setPage(p);
      setPartners(Array.isArray(list) ? list : []);
    }).catch(err => setError(err.message)).finally(() => setLoading(false));
    return () => { mounted = false; };
  }, []);

  const grouped = useMemo(() => {
    const map = { advisory: [], scientific: [], partners: [] };
    partners.forEach(partner => {
      const section = partner.section || 'advisory';
      if (map[section]) map[section].push(partner);
      else map.advisory.push(partner);
    });
    return map;
  }, [partners]);

  if (loading) return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Oval height={48} width={48} color="#2E8B57" secondaryColor="#CDEAD7" />
    </div>
  );
  if (error) return <div style={{ padding: 20 }}>Error: {error}</div>;

  return (
    <Page>
      <Header>
        <HeaderCard>
          <h1>{page?.title || 'Partnerships'}</h1>
          <p>{page?.description || ''}</p>
        </HeaderCard>
        <HeaderImage>
          {page?.image ? <LazyImage src={page.image} alt="Partnerships header" /> : null}
        </HeaderImage>
      </Header>

      {SECTIONS.map(({ key, label }) => {
        const list = grouped[key];
        if (!list || list.length === 0) return null;
        return (
          <Section key={key}>
            <SectionTitle>{label}</SectionTitle>
            <Grid>
              {list.map(pt => (
                <Card key={pt._id}>
                  {pt.image ? <LazyImage src={pt.image} alt={pt.name} /> : null}
                  <h3>{pt.name}</h3>
                  {pt.link ? <a href={pt.link} target="_blank" rel="noreferrer">Visit website</a> : null}
                </Card>
              ))}
            </Grid>
          </Section>
        );
      })}
    </Page>
  );
};

export default Partnerships;
